var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-wrapper",class:[_vm.basis, {container: _vm.container}],style:(_vm.container && {'max-width': _vm.container + 'px'})},[(_vm.row)?_c('div',{staticClass:"row"},[_vm._t("default")],2):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }